import { render, staticRenderFns } from "./CompanyExpensesAddEditView.vue?vue&type=template&id=28bcdb22&scoped=true&"
import script from "./CompanyExpensesAddEditView.vue?vue&type=script&lang=js&"
export * from "./CompanyExpensesAddEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bcdb22",
  null
  
)

export default component.exports